// Pinia Store - 认证状态管理
import { defineStore } from 'pinia';
export const useAuthStore = defineStore('auth', {
    state: () => {
        const token = localStorage.getItem('token') || '';
        const userInfoStr = localStorage.getItem('userInfo');
        let userInfo = null;
        if (userInfoStr && userInfoStr !== 'null' && userInfoStr !== 'undefined') {
            try {
                userInfo = JSON.parse(userInfoStr);
            }
            catch (error) {
                console.error('Failed to parse userInfo from localStorage:', error);
                localStorage.removeItem('userInfo');
            }
        }
        return {
            token,
            userInfo,
            isLoggedIn: !!(token && userInfo)
        };
    },
    getters: {
        // 是否已认证
        isAuthenticated: (state) => !!state.token && !!state.userInfo,
        // 用户类型
        userType: (state) => state.userInfo?.user_type || '',
        // 用户名
        userName: (state) => state.userInfo?.username || '',
        // 用户昵称
        userNickname: (state) => state.userInfo?.nickname || state.userInfo?.username || '',
        // 是否是管理员
        isAdmin: (state) => state.userInfo?.user_type === 'admin',
        // 是否是代理
        isAgent: (state) => state.userInfo?.user_type === 'agent',
        // 用户余额
        userBalance: (state) => state.userInfo?.balance || 0
    },
    actions: {
        // 登录
        login(token, userInfo) {
            this.token = token;
            this.userInfo = userInfo;
            this.isLoggedIn = true;
            // 持久化存储
            localStorage.setItem('token', token);
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        },
        // 登出
        logout() {
            this.token = '';
            this.userInfo = null;
            this.isLoggedIn = false;
            // 清除存储
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
        },
        // 更新用户信息
        updateUserInfo(userInfo) {
            if (this.userInfo) {
                this.userInfo = { ...this.userInfo, ...userInfo };
                localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
            }
        },
        // 更新余额
        updateBalance(balance) {
            if (this.userInfo) {
                this.userInfo.balance = balance;
                localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
            }
        },
        // 检查认证状态
        checkAuth() {
            const token = localStorage.getItem('token');
            const userInfo = localStorage.getItem('userInfo');
            if (token && userInfo) {
                try {
                    this.token = token;
                    this.userInfo = JSON.parse(userInfo);
                    this.isLoggedIn = true;
                    return true;
                }
                catch (error) {
                    console.error('Failed to parse user info:', error);
                    this.logout();
                    return false;
                }
            }
            return false;
        },
        // 验证token是否有效（可选实现）
        async validateToken() {
            if (!this.token) {
                return false;
            }
            try {
                // 这里可以调用后端API验证token
                // 暂时返回true，依赖HTTP拦截器处理过期token
                return true;
            }
            catch (error) {
                console.error('Token validation failed:', error);
                this.logout();
                return false;
            }
        }
    }
});
